/*
 * @FilePath     : /fe-eshotel/src/components/picker/props.js
 * @Author       : LiYang
 * @Date         : 2022-01-26 15:22:34
 * @LastEditTime : 2022-01-27 18:50:00
 * @LastEditors  : Please set LastEditors
 * @Description  : 
 */
export default {
  cancelText: {
    type: String,
    value: '取消'
  },
  confirmText: {
    type: String,
    value: '确定'
  },
  
  indicatorStyle: {
    type: Object,
    value: {
      height: '38px'
    }
  },
  height: {
    type: String,
    value: '240px'
  },
  immediateChange: {
    type: Boolean,
    value: false
  },
  title: String,
  showToolBar: Boolean,
}